<template>
  <div class="javaPage">
     <template v-if="from!='introDetail'">
      <div id="block"></div>
      <Header />
      <Box1 />
    </template>
    <Box9 />
  
    <Box2 />
    <Box3 @openPop="openPop"/>
    <Box4 />
    <Box5 />
    <Box6  @openPop="openPop"/>
    <Box7 />
    <Box8 />
    <pageRightFloat pageName="nau-北亚利桑那大学"/>
    <Footer />
    <van-popup
      v-model="showPopup"
      position="bottom"
      closeable
      round
      :style="{  overflowY: 'hidden' }"
      @close="onClose"
    >
      <div class="codePopup">
        <h1>{{operationTitle}}</h1>
        <div class="content">
          <div class="img"><img :src="src"/></div>
          <p>{{operationTxt}}</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9 from "./Box9.vue";

import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
export default {
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    pageRightFloat,
    Header,
    Footer,
   
  },
  data() {
    return {
      flag: false,
      src: null,
      operationTitle:"",
      operationTxt:"",
      showPopup:false,
     from:''
    };
  },
  mounted() {
    this.from=this.getQueryString("from")
  },

  methods: {
    openPop(type){
      if(type=='zixun'){
        this.showPopup=true
        this.operationTitle="咨询客服"
        this.operationTxt="长按识别二维码，了解项目详情"
        this.src=require("../../../assets/coursePage/design/box3/code.png")
      }else{
        this.showPopup=true
        this.operationTitle="添加老师，免费激活学习"
        this.operationTxt="长按识别二维码，领取福利"
        this.src=require("../../../assets/coursePage/design/box6/code.png")
      }
    },
    onClose() {
      this.showPopup = false;
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
   
    close() {
      this.src = "";
      this.flag = false;
    },
    zixun(name) {
      zhuge.track("H5_北亚利桑那大学专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-popup__close-icon {
  position: absolute;
  top: 52px !important;
  width: 32px;
  height: 32px;
  right: 48px !important;
  font-size: 32px;
}

.van-popup {
  padding-bottom:calc(64px + constant(safe-area-inset-bottom));
  padding-bottom:calc(64px + env(safe-area-inset-bottom));
  padding-top: 48px;
  box-sizing: border-box;
}
.codePopup {
  h1 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 36px;
    color: #1d2129;
    line-height: 52px;
    text-align: center;
    font-style: normal;
  }
  .content {
    width: 558px;
    height: 396px;
    margin: 0 auto;
   
    .img{
      width: 280px;
      height: 280px;
      background: #ffffff;
      box-shadow: 0px 8px 38px 6px rgba(0, 0, 0, 0.05),
        0px 20px 30px 2px rgba(0, 0, 0, 0.04),
        0px 10px 12px -6px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      margin: 56px auto 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: 255px;
      height: 255px;
      display: block;
     
    }
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #1d2129;
      line-height: 44px;
      text-align: center;
      font-style: normal;
    }
  }
}
/deep/ .swiper-pagination-bullet {
      opacity: 1;
}
#block {
  width: 100%;
  height: 88px;
}
.show {
  width: 222px !important;
  .video-text {
    width: 100% !important;
  }
}
.video-float {
  transition: all 0.5s;
  position: fixed;
  right: 0;
  top: 136px;
  width: 10px;
  height: 64px;
  background: #ffffff
    linear-gradient(
      142deg,
      rgba(214, 222, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
  box-shadow: 0px 4px 24px -8px rgba(94, 123, 218, 0.4);
  border-radius: 200px 0px 0px 200px;
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 29;

  .play-btn {
    background: url("../../../assets/coursePage/java/javaPlay.png");
    width: 36px;
    height: 36px;
    background-size: cover;
    display: inline-block;
    flex-shrink: 0;
    margin: 0px 12px 0px 16px;
  }

  .video-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #273f6e;
    white-space: nowrap;

    width: 0;
    overflow: hidden;
  }
}
</style>
